import React, { useEffect } from 'react';
import styles from './FilterTabStatus.module.sass';
import CssHelper from 'Services/Utils/Css/CssHelper';
import FontAwesomeIcon from 'Components/Atoms/FontAwesomeIcon/FontAwesomeIcon';
import {faChevronDown} from '@fortawesome/pro-solid-svg-icons';
import Grid from 'Components/Atoms/Grid/Grid';
import Checkbox from 'Components/Atoms/Checkbox/Checkbox';
import StatusLabel from 'Components/Atoms/Label/StatusLabel/StatusLabel';

interface Props {
    isOpen?: boolean
    values: any[]
    filterList: any[]
    onTabClick: any
    onFilterClick: any
}

const FilterTabStatus = ({
    isOpen,
    values,
    filterList,
    onTabClick,
    onFilterClick
}: Props) => {
    const cssClass = CssHelper.createCssClass(`
        ${styles['filtertabstatus__content-item']}
        ${styles['filtertabstatus__content-item__state--'+(isOpen?'open':'closed')]}
        ${styles['filtertabstatus__content-item__filters--'+(values.length > 0?'active':'inactive')]}
    `)

    return <div className={cssClass}>
        <div
            className={styles['filtertabstatus__content-item-header']}
            onClick={onTabClick}
        >
            Status { values.length > 0 && <>({ values.length }/{filterList.length})</> }
            <div
                className={styles['filtertabstatus__content-item-header-icons']}
            >
                <FontAwesomeIcon
                    icon={faChevronDown}
                    className={styles['filtertabstatus__content-item-header-arrow']}
                />
            </div>
        </div>

        {
            isOpen &&
            <Grid>
                <div className={styles['filtertabstatus__content-item-list']}>
                    {
                        filterList.map(i => {
                            return <div className={styles['entityoverviewfiltermodal__content-item-list-item']}>
                                <Checkbox
                                    state={values.includes(i?.value) ? 'active' : 'inactive'}
                                    onClick={() => onFilterClick(i?.value)}
                                    label={
                                        <StatusLabel status={i?.status}>
                                            { i?.label }
                                        </StatusLabel>
                                    }
                                />
                            </div>
                        })
                    }
                </div>
            </Grid>
        }
    </div>
}

export default FilterTabStatus;